import { render, staticRenderFns } from "./writeoffForUser.vue?vue&type=template&id=194222b2&scoped=true&"
import script from "./writeoffForUser.vue?vue&type=script&lang=js&"
export * from "./writeoffForUser.vue?vue&type=script&lang=js&"
import style0 from "./writeoffForUser.vue?vue&type=style&index=0&id=194222b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194222b2",
  null
  
)

export default component.exports